import { createContext, useContext, useEffect, useState } from "react";
import Tracker from '@openreplay/tracker';
import noop from "../functions/noop";
import { UserContext } from "./UserContext";

const SessionReplayContext = createContext();

const key = "_fp_SessionReplay";
const projectKey = process.env.REACT_APP_SESSION_REPLAY_PROJECT_KEY;

export function SessionReplayProvider({ children }) {
  const { user } = useContext(UserContext);
  const [tracker, setTracker] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const enableSessionReplay = () => setIsEnabled(true);

  useEffect(() => {
    if (localStorage.getItem(key) !== 'enabled') return noop;

    enableSessionReplay();
  }, []);

  useEffect(() => {
    if (!projectKey) return;
    if (!isEnabled || tracker) return noop;

    setTracker(new Tracker({
      projectKey,
      __DISABLE_SECURE_MODE: true,
    }));

  }, [isEnabled, tracker]);

  useEffect(() => {
    if (!tracker || tracker.isActive()) return noop;
    tracker.start();
    localStorage.setItem(key, 'enabled');
  }, [tracker]);

  useEffect(() => {
    if (!tracker || !user) return noop;

    if (user.email) {
      tracker.setUserID(user.email);
    } else {
      tracker.setUserAnonymousID(user.uid);
    }
  }, [user, tracker]);


  return <SessionReplayContext.Provider value={{ enableSessionReplay }}>
    {children}
  </SessionReplayContext.Provider>

}

export default SessionReplayContext
